import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PlantsEntity } from "../plants/plants.entity";

@Entity('department')

export class DepartmentEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id"
    })
    id: number

    @Column('varchar', {
        name: 'department_name',
        nullable: true
    })
    departmentName: string;

    @Column('varchar', {
        name: 'hod',
        nullable: true
    })
    hod: string;
    
    @Column('int', {
        name: 'hod_id',
        nullable: true
    })
    hodId: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'role'
    })
    role: string | null;

    @ManyToOne(() => PlantsEntity, plant => plant.departmentInfo)
    @JoinColumn({ name: 'plant_id' })
    plantsInfo: PlantsEntity;

}